import type { Maybe } from '@adornis/base/utilTypes.js';
import { ID } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import { OSCE } from '@ils/osces/db/osce.js';
import { ExamSlotRatingDoc } from '@ils/ratings/db/rating.js';
import { Slot } from '@ils/slots/db/slot.js';
import { Names } from '@ils/static/names.js';
import { ILSUser } from '../../../src/db/ils-user.js';

@Entity()
export class RatingsExportLine extends AdornisEntity {
  static override _class = Names.RatingsExportLine._class;

  static override resolveID(entity: RatingsExportLine): string {
    return entity._id;
  }

  @Field(type => ID) _id!: string;
  @Field(type => ExamSlotRatingDoc) ratingDoc!: ExamSlotRatingDoc;
  @Field(type => Slot) slot!: Slot;
  @Field(type => ILSUser) trainee!: ILSUser;
  @Field(type => [ILSUser]) inspectors!: [ILSUser, Maybe<ILSUser>];
  @Field(type => OSCE) osce!: OSCE;
  // @Field(type => Order) order: Maybe<Order>;
}
